import React, { useState, useEffect, useRef } from "react";
import { v4 as uuidv4 } from 'uuid';
//import axios from 'axios'
import ListResult from "./ListResult";
import datos from "../datos2024.json";
import ReactPixel from 'react-facebook-pixel';
import AlertModal from "../Modal/alertModal";
import iconGeolocalizacion from '../../assets/images/icon-geomapa.webp';
import permisosGeolocalizacion from '../../assets/images/permisos-geolocalizacion.webp';
import iconZona from '../../assets/images/icon-brujula.webp';
import geolocalizacionLarge from '../../assets/images/geolocalizacion-Brios-Desktop.webp';
import geolocalizacionSmall from '../../assets/images/geolocalizacion-Brios-Mobile.webp';

const Search = (props) => {
    const [ip, setIP] = useState(props.ip);
    const [location, setLocation] = useState("");
    const [listItems, setListItems] = useState(Array);
    const [search, setSearch] = useState("");
    const generateId = () => uuidv4();
    const [mobile, setMobile] = useState( window.innerWidth <= 800 );
    const [showModal, setShowModal] = useState(false);
    const cel = "3172360243";
    const listaMinimarketsRef = useRef(null);
    

    const closeModal = () => setShowModal(false);

    const scrollToSection = () => {
        listaMinimarketsRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    
    const getMetros = (lat1, lon1, lat2, lon2) => {
        const rad = (x) => { return x * Math.PI / 180; }
        var R = 6378.137; //Radio de la tierra en km
        var dLat = rad(lat2 - lat1);
        var dLong = rad(lon2 - lon1);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        return d.toFixed(3) * 1000; //Retorna tres decimales
    }

    const handleLocation = () => {
        const output = document.getElementById('message');

        // Verifica si el navegador soporta geolocalización
        if (navigator.geolocation) {
            console.log('ingresa');
            // output.innerHTML = "<p>Tu navegador soporta geolocalización</p>"

            // Obtener latitud y longitud
            navigator.geolocation.getCurrentPosition((pos) => {
                var lat = pos.coords.latitude;
                var lon = pos.coords.longitude;

                const A = datos; // Lista de minimarkets
                const B = []; // Lista de minimarkets cercanos

                A.map((data) => {
                    if (parseInt(getMetros(lat, lon, data.lat, data.lon)) <= 3000) {
                        //console.log('distancia', parseInt(getMetros(lat, lon, data.lat, data.lon)));
                        data.dist = parseInt(getMetros(lat, lon, data.lat, data.lon));
                        B.push(data);
                        setLocation("");
                    }
                }, locationError);

                if (B.length === 0) {
                    A.map((data) => {
                        //console.log('distancia', parseInt(getMetros(lat, lon, data.lat, data.lon)));
                        if (parseInt(getMetros(lat, lon, data.lat, data.lon)) <= 6000) {
                            data.dist = parseInt(getMetros(lat, lon, data.lat, data.lon));
                            B.push(data);
                            setLocation("");
                        }
                    }, locationError);

                    if (B.length === 0) {

                        output.innerHTML = `<div class="alert alert-danger" role="alert">
                        No hay resultados cercanos.</div>
                        <p>Si tienes problemas para encontrar tu minimarket llamanos o escríbenos para ayudarte</p>`;

                        const data = {
                            "name": "Brios",
                            "address": "",
                            "barrio": "",
                            "lat": "",
                            "lon": "",
                            "tel": cel,
                            "tel2": "",
                            "tel3": "",
                            "horario": "",
                            "wtp": true
                        };
                        B.push(data);

                    } else {
                        output.innerHTML = `<div class="alert alert-success" role="alert">
                        Se encontraron `+ B.length + ` resultados. </br> Se muestran primero los más cercanos a tu localidad.
                        </div>`
                    }

                } else {

                    output.innerHTML = `<div class="alert alert-success" role="alert">
                    Se encontraron `+ B.length + ` resultados. </br> Se muestran primero los más cercanos a tu localidad.
                    </div>`;
                }

                setListItems(B);
                //window.location.href = "#listaMinimarkets"
                scrollToSection();

                let current_timestamp = Math.floor(new Date() / 1000);
                const id_event = generateId();

                // Enviar el evento al Pixel de Facebook en el cliente
                ReactPixel.track('FindLocation', 
                { 
                    eventID: id_event,
                    fbc: props.fbc,
                    fbp: props.fbp,
                    custom_data: {
                        content_type: "Geolocalizacion realizada"
                    }
                });

                // Datos del evento para enviar al servidor de Facebook
                const data = {
                    "data": [
                        {
                            "event_name": "FindLocation",
                            "event_time": current_timestamp,
                            "event_id": id_event,
                            "action_source": "website",
                            "user_data": {
                                "client_ip_address": ip,
                                "client_user_agent": window.navigator.userAgent,
                                "fbc": props.fbc,
                                "fbp": props.fbp
                            },
                            "custom_data": {
                                "content_type": "Geolocalizacion realizada"
                            }
                        }
                    ]
                };

                // Enviar el evento al servidor de Facebook
                fetch(
                    `https://graph.facebook.com/v12.0/${props.pixel_id}/events?access_token=${props.access_token}`,
                    {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(data)
                    }
                )
                .then(response => response.json())
                .then(response => {
                    console.log(data);
                    console.log('Evento enviado con éxito:', response);
                })
                .catch(error => {
                    console.error('Error al enviar el evento:', error);
                });

            }, locationError);

            document.getElementById("searchMinimarket").reset();
            //console.log('array B', B)

        } else {
            output.innerHTML = `<div class="alert alert-danger" role="alert">
            Tu navegador no soporta geolocalización
          </div>`;

        }
    }

    // Manejar errores de geolocalización
    const locationError = (error) => {
        const output = document.getElementById('message');
        console.log(error);
        if (error.code === 1) {
            output.innerHTML = `<div class="alert alert-danger" role="alert">
            No has permitido el acceso a tu ubicación. Dale clic en PERMITIR para ver los resultados.
            </div>`;
            setLocation("no-permiso");
        } else {
            output.innerHTML = `<div class="alert alert-danger" role="alert">
            No se pudo obtener tu ubicacion
            </div>`;
            setLocation("no-permiso");
        }
    }

    const findMinimarket = (value, lookFor) => {
        const text = value.toLowerCase();
        const B = [];
        const output = document.getElementById('message');

        datos.map((data) => {
            if (lookFor === 'barrio' && data.barrio.toLowerCase().indexOf(text) !== -1) {
                B.push(data);
            }

            if (lookFor === 'zona' && data.zona.toLowerCase().indexOf(text) !== -1 ){
                B.push(data);
            }
        });

        if (B.length === 0) {
            output.innerHTML = `<div class="alert alert-danger" role="alert">
            No hay resultados similares.<br/>
          </div>
          <p>Si tienes problemas para encontrar tu minimarket llamanos o escríbenos para ayudarte</p>
          `;
            const data = {
                "name": "Brios",
                "address": "",
                "barrio": "",
                "lat": "",
                "lon": "",
                "tel": cel,
                "tel2": "",
                "tel3": "",
                "horario": "",
                "wtp": true
            };
            B.push(data);

        } else {
            output.innerHTML = `<div class="alert alert-success" role="alert">
            Se encontraron `+ B.length + ` resultados
          </div>`;
        }
        setListItems(B);

    }

    const onChangeSelect = (e) => {
        const output = document.getElementById('message');
        let value = e.target.value;
        if(value === ""){
            setListItems([]);
            output.innerHTML = "";
        }else{
            findMinimarket(value, 'zona');

            let current_timestamp = Math.floor(new Date() / 1000);
            const id_event = generateId();

            // Enviar el evento al Pixel de Facebook en el cliente
            ReactPixel.track('FindLocation', 
            { 
                eventID: id_event,
                fbc: props.fbc,
                fbp: props.fbp,
                custom_data: {
                    content_type: "Busqueda por zona "+value
                }
            });

            // Datos del evento para enviar al servidor de Facebook
            const data = {
                "data": [
                    {
                        "event_name": "FindLocation",
                        "event_time": current_timestamp,
                        "event_id": id_event,
                        "action_source": "website",
                        "user_data": {
                            "client_ip_address": ip,
                            "client_user_agent": window.navigator.userAgent,
                            "fbc": props.fbc,
                            "fbp": props.fbp
                        },
                        "custom_data": {
                            "content_type": "Busqueda por zona "+value
                        }
                    }
                ]
            };

            // Enviar el evento al servidor de Facebook
            fetch(
                `https://graph.facebook.com/v12.0/${props.pixel_id}/events?access_token=${props.access_token}`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                }
            )
            .then(response => response.json())
            .then(response => {
                console.log(data);
                console.log('Evento enviado con éxito:', response);
            })
            .catch(error => {
                console.error('Error al enviar el evento:', error);
            });
        }
        setLocation("");
    }

    const onChange = (e) => {
        const output = document.getElementById('message');
        let value = e.target.value;
        setSearch(value);
        if (value.length >= 3) {
            findMinimarket(value, 'barrio');

            if (value.length === 3) {

                let current_timestamp = Math.floor(new Date() / 1000);
                const id_event = generateId();

                // Aqui va el codigo de PIXEL para cuando busca en el input BUSCAR BARRIO
                ReactPixel.track('Search', 
                { 
                    eventID: id_event, 
                    content_category: "Encontrar minimarket por Barrio", 
                    search_string: value,
                    fbc: props.fbc,
                    fbp: props.fbp 
                }, 
                { 
                    eventID: id_event 
                });

                // Aqui va el codigo de SERVIDOR de pixel para cuando busca en el input BUSCAR BARRIO

                const data = {
                    "data": [
                        {
                            "event_name": "Search",
                            "event_time": current_timestamp,
                            "event_id": id_event,
                            "action_source": "website",
                            "user_data": {
                                "client_ip_address": ip,
                                "client_user_agent": window.navigator.userAgent,
                                "fbc": props.fbc,
                                "fbp": props.fbp
                            },
                            "custom_data": {
                                "content_category": "Encontrar minimarket por Barrio",
                                "search_string": value
                            }
                        }
                    ]
                };

                fetch(
                    `https://graph.facebook.com/v12.0/${props.pixel_id}/events?access_token=${props.access_token}`,
                    {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(data)
                    }
                )
                .then(response => response.json())
                .then(response => {
                console.log('Evento enviado con éxito:', response);
                })
                .catch(error => {
                console.error('Error al enviar el evento:', error);
                });
            }

        } else {
            setListItems([]);
            output.innerHTML = "";
        }
    }

    const handleKeyDown = (e) => {
        let value = e.target.value;
        if (e.key === 'Enter' && search != "") {
            //console.log("on press enter");
            if (value.length >= 3) {
                findMinimarket(value, 'barrio');
            }
        }
    }

    

    const redirectWhatsapp = (data) => {
        if (data.tel != "" && data.tel.substr(0, 1) == 3) {

            let current_timestamp = Math.floor(new Date() / 1000);
            const id_event = generateId();

            // Aqui va el codigo de PIXEL para cuando le da clic en Whatsapp
            //ReactPixel.trackCustom('Whatsapp', { nombre_minimarket: data.name, telefono: data.tel });
            ReactPixel.track('Contact', 
            { 
                eventID: id_event, 
                custom_data: 
                { 
                    nombre_minimarket: data.name, 
                    telefono: data.tel 
                },
                fbc: props.fbc,
                fbp: props.fbp 
            }, 
            { 
                eventID: id_event 
            });


            //Aqui va el codigo de SERVIDOR para Pixel cuando le da clic en whatsapp
            const datas = {
                "data": [
                    {
                        "event_name": "Contact",
                        "event_time": current_timestamp,
                        "event_id": id_event,
                        "action_source": "website",
                        "user_data": {
                            "client_ip_address": ip,
                            "client_user_agent": window.navigator.userAgent,
                            "fbc": props.fbc,
                            "fbp": props.fbp
                        },
                        "custom_data": {
                            "nombre_minimarket": data.name,
                            "telefono": data.tel
                        }
                    }
                ]
            };

            fetch(
                `https://graph.facebook.com/v12.0/${props.pixel_id}/events?access_token=${props.access_token}`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(datas)
                }
            )
            .then(response => response.json())
            .then(response => {
                console.log('Evento enviado con éxito:', response);
                window.open('https://wa.me/' + '+57' + data.tel)
            })
            .catch(error => {
                console.error('Error al enviar el evento:', error);
            });
        }
    }

    const redirectLLamar = (data) => {
        var phone = "";
        if (data.tel != "") {
            phone = data.tel;
        } else if (data.tel2 != "") {
            phone = data.tel2;
        } else if (data.tel3 != "") {
            phone = data.tel3;
        }

        let current_timestamp = Math.floor(new Date() / 1000);
        const id_event = generateId();

        // Codigo de PIXEL para cuando le dan clic en llamar
        ReactPixel.track('Contact', 
        { 
            eventID: id_event, 
            custom_data: { 
                nombre_minimarket: data.name, 
                telefono: phone 
            },
            fbc: props.fbc,
            fbp: props.fbp 
        }, 
        { 
            eventID: id_event 
        });

        // Codigo de SERVIDOR de pixel cuando le dan clic en llamar
        const datas = {
            "data": [
                {
                    "event_name": "Contact",
                    "event_time": current_timestamp,
                    "event_id": id_event,
                    "action_source": "website",
                    "user_data": {
                        "client_ip_address": ip,
                        "client_user_agent": window.navigator.userAgent,
                        "fbc": props.fbc,
                        "fbp": props.fbp
                    },
                    "custom_data": {
                        "nombre_minimarket": data.name,
                        "telefono": phone
                    }
                }
            ]
        };

        fetch(
            `https://graph.facebook.com/v12.0/${props.pixel_id}/events?access_token=${props.access_token}`,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(datas)
            }
        )
        .then(response => response.json())
        .then(response => {
            console.log('Evento enviado con éxito:', response);
            window.location = `tel:${'+57' + phone}`;
        })
        .catch(error => {
            console.error('Error al enviar el evento:', error);
        });
    }

    return (<div>

        <div className="form-group row">
            <div ref={listaMinimarketsRef} id="listaMinimarkets" className="col-sm-12 col-md-12 col-lg-12 text-end">
                <form id="searchMinimarket">
                    <div className="row">
                        <div className="col-sm-12 col-md-6 col-lg-6 text-start">
                            <button type="button" onClick={() => setShowModal(true)} className="btn btn-primary appbtn px-3 py-2 w-100 mb-3">
                                <img src={iconGeolocalizacion} alt="icono punto de venta" width="71px" /> <span>Tu ubicación actual</span>
                            </button>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6 text-start">
                            <div className="control">
                                <div className="content-select">
                                    <select className="form-control" name="zona" onChange={onChangeSelect}>
                                        <option value="">Zona de Cali</option>
                                        <option value="norte">Zona Norte</option>
                                        <option value="sur">Zona Sur</option>
                                    </select>
                                    <i></i>
                                </div>
                                <span className="icon-select">
                                    <img src={iconZona} alt="icono zona Cali" height="60px" />
                                </span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div className="col-sm col-md-12 col-lg-12">
                {/*<input type="text" name="barrio" onChange={onChange} onKeyDown={handleKeyDown} className="form-control py-4" placeholder="Ingresa el nombre de tu barrio" />*/}
                {/*<p>{datos.length}</p>*/}
                <div id="message" className="mt-3"></div>
                {location === "no-permiso" &&
                    <>
                    <a className="d-block" onClick={handleLocation}>
                        <span className="alert alert-warning d-block" role="alert">
                            <span className="row">
                                <span className="col-sm col-md-12 col-lg-6 p-2">
                                    <img className="img-fluid" src={permisosGeolocalizacion} alt="Permitir usar la ubicación de tu dispositivo." />
                                </span>
                                <span className="col-sm col-md-12 col-lg-6 p-2">
                                    Darle <strong>clic en PERMITIR</strong> para ver los resultados más cercanos a tu ubicación.
                                </span>
                            </span>
                        </span>
                    </a>
                    <div className="text-start">
                        <p><strong>¿No funciona?</strong></p>
                        <p>Sigue los pasos a continuación para permitir el acceso:</p><br/>
                        {!mobile ? 
                            <>
                                <ol>
                                    <li>Haz clic en el <strong>icono del candado</strong> en la barra de direcciones de tu navegador.</li>
                                    <li>Selecciona <strong>"Configuración del sitio"</strong> (Site settings) o <strong>"Permisos del sitio"</strong>.</li>
                                    <li>Encuentra <strong>"Ubicación"</strong> (Location) y selecciona <strong>"Permitir"</strong> (Allow).</li>
                                    <li><strong>Recarga la página y vuelve a intentar.</strong></li>
                                </ol>
                            </>
                            :
                            <>
                                <ol>
                                    <li>Abre la <strong>configuración de tu navegador</strong>.</li>
                                    <li>Ve a <strong>"Configuración del sitio"</strong> (Site settings).</li>
                                    <li>Selecciona <strong>"Permisos"</strong> y luego <strong>"Ubicación"</strong> (Location).</li>
                                    <li>Encuentra a www.brios.com.co en la lista y selecciona <strong>"Permitir"</strong> (Allow).</li>
                                    <li><strong>Vuelve al navegador y recarga la página.</strong></li>
                                </ol>
                                
                            </>
                        }                    
                    </div>
                    </>
                }
            </div>
        </div>
        {/*listItems.length == 0 ? datos : listItems*/}
        {<ListResult listItems={listItems} redirectWhatsapp={redirectWhatsapp} redirectLLamar={redirectLLamar} />}

        {showModal && (
            <AlertModal
                onClose={closeModal}
                onAllow={() => handleLocation()}
                imageSrc={{imageSmall: geolocalizacionSmall, imageLarge: geolocalizacionLarge}}
                title="Permiso Localización GPS"
                description="Para mostrarte los puntos de venta más cercanos a tu ubicación, debes <strong style='font-size: 20px'>PERMITIR</strong> el acceso a tu ubicación GPS"
                /*Necesitamos acceder a tu ubicación para ofrecerte una mejor experiencia. Por favor, permite el acceso cuando se te solicite*/
            />
        )}
    </div>)
}

export default Search;